import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 290CA835-F009-4630-87D3-D4515E1F5527
 * name engine
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/engine.svg
 * tags
 * - Automotive 
 */
export const EngineIcon = createSvgIcon(<><path d="M7,4V6H10V8H7L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V16H20V19H23V9H20V12H18V8H12V6H15V4H7Z" /></>, 'EngineIcon');
export default EngineIcon